import styled from 'styled-components';

export interface BgProps {
  Bg: string;
}

export const FadeWrapper = styled.div`
  position: absolute;

  width: 100vw;

  &.fade-enter {
    opacity: 0;
    transform: scale(1.1);
  }

  &.fade-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: opacity 300ms, transform 300ms;
  }

  &.fade-exit {
    opacity: 1;
    transform: scale(1);
  }

  &.fade-exit-active {
    opacity: 0;
    transform: scale(0.9);
    transition: opacity 300ms, transform 300ms;
  }
`;

export const QFBButton = styled.button`
  padding: 0.5em 1.5em;
  border-radius: 3px;
  cursor: pointer;
  font-family: 'Lato';
  font-size: 1rem;
  outline: none;
  position: relative;
  width: 100%;
  background: #630dbf;
  border: 2px solid #630dbf;
  color: #eee;

  &:hover {
    background-color: ${({ theme }) => theme.qfb2Fade};
    border-color: ${({ theme }) => theme.qfb2Fade};
  }

  &:disabled {
    background-color: #495057;
    border-color: #495057;
    color: #6c757d;
  }
`;

export const ReturnButton = styled.div`
  background: transparent;
  border: none;
  color: white;
  font-family: 'Lato';
  font-size: 1.1rem;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  & .icon {
    background-color: ${({ theme }) => theme.primary};
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    width: 36px;
    margin-right: 1em;
  }

  &:hover .icon {
    background-color: ${({ theme }) => theme.primarySlightFade};
  }
`;

export const LandingContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 15px;
  margin: 0 auto;
  max-width: 768px;
  padding: 2em;
`;
